<page-load-header *ngIf="!initialized"></page-load-header>
<form class="form" (ngSubmit)="onSave()" #myForm="ngForm" novalidate>
  <div *ngIf="initialized" class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">CE Evaluation</h5>
    </div>

    <div class="modal-body">
      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>
      <h5>Instruction</h5>
      <strong>1. The Program objectives were met:</strong>
      <div class="form-group ml-5">
        <label for="inputAddress"
          ><address></address>
          a. {{ courseEvent.learningObjective1 }}</label
        >
        <select [(ngModel)]="model.learningObjective1Met" required class="form-control" name="learningObjective1Met">
          <option value="">Please Choose...</option>
          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group ml-5">
        <label for="inputAddress">b. {{ courseEvent.learningObjective2 }}</label>
        <select [(ngModel)]="model.learningObjective2Met" required class="form-control" name="learningObjective2Met">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group ml-5">
        <label for="inputAddress">c. {{ courseEvent.learningObjective3 }}</label>
        <select [(ngModel)]="model.learningObjective3Met" required class="form-control" name="learningObjective3Met">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>2. Content was appropriate for my level training.</strong></label>
        <select [(ngModel)]="model.contentAppropriate" required class="form-control" name="contentAppropriate">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>3. Teaching methods were effective.</strong></label>
        <select [(ngModel)]="model.teachingMethodsEffective" required class="form-control" name="teachingMethodsEffective">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>4. Visual aids, handouts (when applicable), and oral presentations clarified content.</strong></label>
        <select [(ngModel)]="model.visualAidsClarified" required class="form-control" name="visualAidsClarified">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <h5>Professional & Ethical Issues</h5>
      <strong>5. Presenter made clearly evident, prior to registration, the following:</strong>
      <div class="form-group ml-5">
        <label for="inputAddress"
          ><address></address>
          A. Requirements for successful completion of activity</label
        >
        <select [(ngModel)]="model.clarityRequirements" required class="form-control" name="clarityRequirements">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group ml-5">
        <label for="inputAddress"
          ><address></address>
          B. Commercial support for CE program, sponsor, or instructor (or any other relationship that may be reasonably construed as a conflict of interest)</label
        >
        <select [(ngModel)]="model.clarityCommercialSupport" required class="form-control" name="clarityCommercialSupport">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group ml-5">
        <label for="inputAddress"
          ><address></address>
          C. Commercial support for content of instruction (e.g., research grants) that could be construed as a conflict of interest</label
        >
        <select [(ngModel)]="model.clarityResearchGrants" required class="form-control" name="clarityResearchGrants">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group ml-5">
        <label for="inputAddress"
          ><address></address>
          D. Commercial support or benefit for endorsement of products (e.g., books, trainings, etc)</label
        >
        <select [(ngModel)]="model.clarityBooksTrainings" required class="form-control" name="clarityBooksTrainings">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group ml-5">
        <label for="inputAddress"
          ><address></address>
          E. Accuracy and utility of the materials presented, the basis of such statements, the limitations of the content being taught and the severe and most common risks</label
        >
        <select [(ngModel)]="model.clarityAccuracy" required class="form-control" name="clarityAccuracy">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <h5>Learning</h5>
      <div class="form-group">
        <label for="inputAddress"><strong>6. Information could be applied to my practice or other work context</strong></label>
        <select [(ngModel)]="model.learningCanBeApplied" required class="form-control" name="learningCanBeApplied">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>7. Information contributes to achieving personal or professional goals</strong></label>
        <select [(ngModel)]="model.learningAcheivingPersonalGoals" required class="form-control" name="learningAcheivingPersonalGoals">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>8. Issues of diversity were addressed</strong></label>
        <select [(ngModel)]="model.learningDiversity" required class="form-control" name="learningDiversity">
          <option value="">Please Choose...</option>

          <option value="5">Strongly Agree</option>
          <option value="4">Agree</option>
          <option value="3">Neutral</option>
          <option value="2">Disagree</option>
          <option value="1">Strongly Disagree</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>9. How much did you learn as a result of this CE program?</strong></label>
        <select [(ngModel)]="model.learningHowMuch" required class="form-control" name="learningHowMuch">
          <option value="">Please Choose...</option>

          <option value="5">A great deal</option>
          <option value="4">A good bit</option>
          <option value="3">Some</option>
          <option value="2">Little</option>
          <option value="1">Very Little</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>10. How useful was the content of this CE program for your practice or other professional development?</strong></label>
        <select [(ngModel)]="model.learningHowUseful" required class="form-control" name="learningHowUseful">
          <option value="">Please Choose...</option>

          <option value="5">Extremely useful</option>
          <option value="4">A good deal useful</option>
          <option value="3">Somewhat useful</option>
          <option value="2">A little useful</option>
          <option value="1">Not Useful</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>11. This program enhanced my professional expertise</strong></label>
        <select [(ngModel)]="model.learningEnhancedProfessionalExpertise" required class="form-control" name="learningEnhancedProfessionalExpertise">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>12. I would recommend this program to others</strong></label>
        <select [(ngModel)]="model.learningWouldRecommend" required class="form-control" name="learningWouldRecommend">
          <option value="">Please Choose...</option>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>

      <h5>Participant Information</h5>
      <div class="form-group">
        <label for="inputAddress"><strong>Please share your profession and status:</strong></label>
        <kendo-multiselect [(ngModel)]="model.professions" name="professions" required [data]="professions" [valuePrimitive]="true" textField="text" valueField="text" [placeholder]="'Click here to choose'" [allowCustom]="false"> </kendo-multiselect>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>Please note years in your profession:</strong></label>
        <select [(ngModel)]="model.yearsInProfession" required class="form-control" name="yearsInProfession">
          <option value="">Please Choose...</option>

          <option value="20+">20+</option>
          <option value="11-20">11-20</option>
          <option value="6-10">6-10</option>
          <option value="1-5">1-5</option>
          <option value="Student">Student</option>
        </select>
        <div class="invalid-message">This field is required</div>
      </div>
      <div class="form-group">
        <label for="inputAddress"><strong>Please share any comments or additional feedback you have regarding the presenter(s) and/or presentation: </strong></label>
        <textarea [(ngModel)]="model.comments" name="comments" class="form-control"></textarea>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-sm btn-admin-primary mr-2" [promiseBtn]="submitComplete" type="submit">
            <span>Save</span>
          </button>
          <button class="btn btn-sm btn-outline-dark" (click)="modal.dismiss('Cross click')" [promiseBtn]="submitComplete" type="button">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</form>
